import { Ionicons } from "@/src/components/ui/ionicons";
import { border, surface, text as uiText } from "@/src/theme/tokens";
import React from "react";
import { Pressable, View } from "react-native";

export function ReturnToLatestButton({ visible, onPress }: { visible: boolean; onPress: () => void }) {
  if (!visible) return null;
  return (
    <View pointerEvents="box-none" style={{ position: "absolute", right: 18, bottom: 10 }}>
      <Pressable
        onPress={onPress}
        accessibilityRole="button"
        accessibilityLabel="Retourner au dernier message"
        hitSlop={6}
        style={{ width: 44, height: 44, borderRadius: 22, alignItems: "center", justifyContent: "center", backgroundColor: surface.primary, borderWidth: 1, borderColor: border.subtle, elevation: 4, shadowColor: "#000", shadowOpacity: 0.16, shadowRadius: 5, shadowOffset: { width: 0, height: 2 } }}
      >
        <Ionicons name="arrow-down" size={21} color={uiText.brand} />
      </Pressable>
    </View>
  );
}
